export const REQUEST_TEXT_STREAM = 'REQUEST_TEXT_STREAM'
export const RECEIVE_TEXT_STREAM = 'RECEIVE_TEXT_STREAM'
export const RECEIVE_TEXT_STREAM_REFLECTED = 'RECEIVE_TEXT_STREAM_REFLECTED'
export const STARTING_COMPLETION = 'STARTING_COMPLETION'
export const SET_ANIMATION = 'SET_ANIMATION'
export const SET_END_OF_STREAM = 'SET_END_OF_STREAM'
export const SET_END_OF_STREAM_REFLECTED = 'SET_END_OF_STREAM_REFLECTED'
export const GET_GENERAL_META_DATA = 'GET_GENERAL_META_DATA'
export const GET_GENERAL_META_DATA_RESULT = 'GET_GENERAL_META_DATA_RESULT'
export const ON_APP_LOAD = 'ON_APP_LOAD'
export const START_PHOTOSHOOT = 'START_PHOTOSHOOT'
export const SCROLL_TEXT = 'SCROLL_TEXT'
export const SET_IS_PHOTO_CAPTURE_OPEN = 'SET_IS_PHOTO_CAPTURE_OPEN'
export const SET_CAPTURED_IMAGE = 'SET_CAPTURED_IMAGE'
export const SET_PHOTO_CAPTURE_WIZARD_STEP = 'SET_PHOTO_CAPTURE_WIZARD_STEP'
export const SET_WHOS_IN_THE_PHOTO = 'SET_WHOS_IN_THE_PHOTO'
export const SAVE_PHOTO = 'SAVE_PHOTO'
export const SET_SHOW_PHOTO_IS_OPEN = 'SET_SHOW_PHOTO_IS_OPEN'
export const PLAY_KEYSTROKE = 'PLAY_KEYSTROKE'
export const TIME_TO_INIT_THEME_AFTER_KEYSTROKE = 20*60*1000 // 20 minutes
export const TERMINATE = 'TERMINATE'
export const SET_PLACEHOLDER_MESSAGE = 'SET_PLACEHOLDER_MESSAGE'
export const TURN_PLACEHOLDER_MESSAGE = 'TURN_PLACEHOLDER_MESSAGE'
export const GET_NEW_SESSION_ID = 'GET_NEW_SESSION_ID'
export const NEW_SESSION_ID_SUCCESS = 'NEW_SESSION_ID_SUCCESS'
export const SET_SHOULD_FOCUS_SEND_BUTTON = 'SET_SHOULD_FOCUS_SEND_BUTTON'
export const SET_SHOULD_FOCUS_INPUT_FIELD = 'SET_SHOULD_FOCUS_INPUT_FIELD'
export const TOPN_BROWSING_DELAY = 350
export const SPEED_MODULATION_DELAY = 50
export const MINIMAL_DEBUG_DELAY = 100
export const TOPN_AFTER_SELECTION_DELAY = 500
export const TIME_TO_WAIT_FOR_NEW_SESSION_ID = 15_000
